import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import store from '@state/store'
// import { abilitiesPlugin } from '@casl/vue'
import '@components/globals/_globals'
import { i18n } from '@src/plugins'
import './vee-validate'
import MgbButton from '@components/button/_button.vue'
// scss
import '@src/design/components/buttons.scss'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Ensure tests fail when Vue emits an error.
    Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

// Registe Globally Components
Vue.component('mgb-button', MgbButton)

const app = new Vue({
    router,
    store,
    i18n: i18n,
    render: (h) => h(App),
}).$mount('#app')

export default app

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
}
